export default __webpack_public_path__ + "static/media/ratheg.88daa783.jpeg";